import { makeAutoObservable } from 'mobx'

import { RangePrice } from 'features/input-range'

import { DifficultTypes, DurationTypes } from 'shared/constants/excursions'

// import { orderExcursionsStore } from '../order-excursions/order-excursions-store'
import { IFindExcursions, ISearchDirection } from './models'

const initialState: IFindExcursions = {
  departure_date: '',
}

class FindExcursionsStore {
  findExcursions: IFindExcursions = initialState

  constructor() {
    makeAutoObservable(this)
  }

  onSelectDirection(direction: ISearchDirection) {
    this.findExcursions = {
      ...this.findExcursions,
      direction: direction.direction_name || '',
      name: direction.name || '',
    }
  }

  onChangeDepartureDate(date: string) {
    this.findExcursions.departure_date = date
  }

  onSetDuration(typeDuration: DurationTypes) {
    this.findExcursions.filter = {
      ...this.findExcursions.filter,
      duration: typeDuration,
    }
  }

  onSetDifficult(typeDifficult: DifficultTypes) {
    this.findExcursions.filter = {
      ...this.findExcursions.filter,
      difficulty_level: typeDifficult,
    }
  }

  onSetRangePrice(onRange: RangePrice) {
    this.findExcursions.filter = {
      ...this.findExcursions.filter,
      price_min: onRange.min,
      price_max: onRange.max,
    }
  }

  onSetTypesExcursions(typesExcursions: string[]) {
    this.findExcursions.filter = {
      ...this.findExcursions.filter,
      types_excursions: typesExcursions,
    }
  }

  onSelectGuides(guidesId: string[]) {
    this.findExcursions.filter = {
      ...this.findExcursions.filter,
      guides_id: guidesId,
    }
  }

  onResetFilter() {
    this.findExcursions.filter = undefined
  }

  onResetForm() {
    this.findExcursions = {
      departure_date: this.findExcursions.departure_date || '',
      direction: this.findExcursions.direction || '',
      name: this.findExcursions.name || '',
    }
  }

  resetDays() {
    this.findExcursions = { ...this.findExcursions, departure_date: '' }
  }

  onSetExcursion(excursion: IFindExcursions) {
    this.findExcursions = excursion
  }
}

export const findExcursionsStore = new FindExcursionsStore()
